import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function Footer({ onManageCookies }) {
  const { t, buildLocalizedPath } = useI18n();

  return (
    <footer
      style={{ backgroundColor: "#181D18", color: "#E7E2D8" }}
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span
                className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-stone-600"
                style={{ backgroundColor: "#2D3B2D" }}
              >
                <span className="font-serif text-lg" style={{ color: "#C59B27" }}>B</span>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-serif text-xl tracking-wide" style={{ color: "#FAF8F5" }}>
                  {t("brand.name")}
                </span>
                <span
                  className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em]"
                  style={{ color: "#C59B27" }}
                >
                  {t("brand.tagline")}
                </span>
              </span>
            </div>
            <p className="mt-6 font-sans text-sm leading-relaxed max-w-xs" style={{ color: "#B8B1A3" }}>
              {t("footer.brand_line")}
            </p>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#C59B27" }}>
              {t("footer.legal_title")}
            </h4>
            <ul className="mt-6 space-y-3 font-sans text-sm">
              <li>
                <Link to={buildLocalizedPath("privacy")} data-testid="footer-privacy" className="hover:text-white">
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link to={buildLocalizedPath("cookie")} data-testid="footer-cookie" className="hover:text-white">
                  {t("footer.cookie")}
                </Link>
              </li>
              <li>
                <Link to={buildLocalizedPath("terms")} data-testid="footer-terms" className="hover:text-white">
                  {t("footer.terms")}
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={onManageCookies}
                  data-testid="footer-manage-cookies"
                  className="hover:text-white text-left"
                >
                  {t("cookie_banner.manage")}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#C59B27" }}>
              {t("footer.contact_title")}
            </h4>
            <ul className="mt-6 space-y-3 font-sans text-sm">
              <li>
                <div style={{ color: "#B8B1A3" }}>{t("footer.address_line_1")}</div>
                <div style={{ color: "#B8B1A3" }}>{t("footer.address_line_2")}</div>
              </li>
              <li>
                <a
                  href={`mailto:${t("footer.email_value")}`}
                  data-testid="footer-email"
                  className="hover:text-white"
                >
                  {t("footer.email_value")}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${t("footer.phone_value").replace(/\s/g, "")}`}
                  data-testid="footer-phone"
                  className="hover:text-white"
                >
                  {t("footer.phone_value")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-stone-800 pt-10 grid gap-6 md:grid-cols-2">
          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#C59B27" }}>
              {t("footer.company_title")}
            </h4>
            <div className="mt-4 font-sans text-sm leading-relaxed" style={{ color: "#B8B1A3" }}>
              <div style={{ color: "#FAF8F5" }}>{t("footer.legal_name")}</div>
              <div className="mt-2">
                {t("footer.piva_label")}: {t("footer.piva_value")} · {t("footer.rea_label")}: {t("footer.rea_value")}
              </div>
              <div>{t("footer.cciaa_label")}</div>
              <div>
                {t("footer.capital_label")}: {t("footer.capital_value")}
              </div>
              <div>
                {t("footer.sian_label")}: {t("footer.sian_value")}
              </div>
              <div>
                {t("footer.dop_label")}: {t("footer.dop_value")}
              </div>
            </div>
          </div>
          <div className="md:text-right">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#C59B27" }}>
              {t("footer.jurisdiction_label")}
            </h4>
            <div className="mt-4 font-sans text-sm leading-relaxed" style={{ color: "#B8B1A3" }}>
              <div>{t("footer.jurisdiction_value")}</div>
              <div className="mt-2">
                {t("footer.incorporation_label")}: {t("footer.incorporation_value")}
              </div>
            </div>
          </div>
        </div>

        <div
          className="mt-10 border-t border-stone-800 pt-6 font-mono text-[11px] uppercase tracking-[0.2em]"
          style={{ color: "#8A8478" }}
        >
          {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}
